import React, { useState } from 'react'
import { getClientTimezone, add, startOfHour } from '@chilipiper/date-time'
import { TimezoneSelect } from '@chilipiper/design-system/src/new'
import * as R from 'remeda'
import { MeetingStartTimes } from '@chilipiper/booking-flow'
import { ScheduleHeader } from './components/ScheduleHeader'
import { StyledBookMeetingContainer } from './styles'
import { BookingMeeting } from './BookingMeeting'

const stableRef = { current: null }

export const BookingFlowMockBlock = () => {
  const [now] = useState(() => new Date())
  const nextWeek = R.range(0, 7).reduce<Record<string, boolean>>((acc, day) => {
    acc[getDateString(add(now, { days: day }))] = true
    return acc
  }, {})

  const slots = R.range(0, 8).map(i => {
    return startOfHour(add(now, { hours: i + 1 })).toISOString()
  })
  const timeSlots: MeetingStartTimes = {
    userIds: ['user-1'],
    startTimes: slots,
    failures: {},
    meetingTypeRef: {
      id: 'mock',
      timestamp: new Date().toISOString(),
    },
  }
  return (
    <StyledBookMeetingContainer>
      <TimezoneSelect
        label={<TimezoneSelect.Label position='hidden'>Preferred timezone</TimezoneSelect.Label>}
        size='S'
        variant='nested'
        hasTime
      />
      <ScheduleHeader
        state='scheduling'
        assignee={{ id: '0', name: 'Disabled' }}
        displayName='Disabled'
        durationInMinutes={30}
        onNextClick={R.doNothing}
        onPreviousClick={R.doNothing}
      />
      <BookingMeeting
        daysWrapperRef={stableRef}
        isLoading={false}
        timezone={getClientTimezone()}
        availableDays={nextWeek}
        timeSlots={timeSlots}
        onSchedule={R.doNothing}
        onSelectSlot={R.doNothing}
        meetingTypeId='mock'
      />
    </StyledBookMeetingContainer>
  )
}

const getDateString = (date: Date) => {
  return date.toISOString().slice(0, 10)
}
